import { useState } from 'react';
import { createFilter } from './BaseFilter';

export const createSelectFilter = ({ field, label, options, valueType = 'string' }) => {
    return createFilter({
        type: 'select',
        field,
        label,

        getInitialState: () => ({
            value: 'all',
            isActive: false
        }),

        applyFilter: (data, currentValue) => {
            if (!currentValue || currentValue === 'all') return data;

            return data.filter(item => {
                const itemValue = valueType === 'number' ? Number(item[field]) : item[field];
                const filterValue = valueType === 'number' ? Number(currentValue) : currentValue;
                return itemValue === filterValue;
            });
        },

        renderFilter: ({ value, onChange }) => {
            return (
                <div style={{ minWidth: '150px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <label className="form-label mb-2">{label}</label>
                    <select
                        className="form-select"
                        style={{ cursor: 'pointer' }}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    >
                        <option value="all">All</option>
                        {options.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
            );
        },

        reset: () => 'all'
    });
};
